import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes } from '@angular/router';

import { UserRouteAccessCrudService } from '../../shared';
// import { JhiPaginationUtil } from 'ng-jhipster';

import {CONFIG} from '../../shared/constants/config.constants';

import {
    SystemSettingComponent,
    // SystemSettingEditComponent,
} from '.';
// import { SystemSettingEditComponent } from './system-setting-edit.component';

@Injectable()
export class SystemSettingResolvePagingParams implements Resolve<any> {

    constructor() {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        const page = route.queryParams['page'] ? route.queryParams['page'] : '1';
        const sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,desc';
        return {
            // page: this.paginationUtil.parsePage(page),
            // predicate: this.paginationUtil.parsePredicate(sort),
            // ascending: this.paginationUtil.parseAscending(sort)
      };
    }
}

export const systemSettingRoute: Routes = [
    {
        path: 'system-setting',
        component: SystemSettingComponent,
        resolve: {
            'pagingParams': SystemSettingResolvePagingParams
        },
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'systemSetting.title',
            permissions: [CONFIG.permissions.systemSetting.R]
        },
        canActivate: [UserRouteAccessCrudService]
    }, 
    {
        path: 'system-setting/:tabId',
        component: SystemSettingComponent,
        resolve: {
            'pagingParams': SystemSettingResolvePagingParams
        },
        data: {
            authorities: ['ROLE_ADMIN'],
            pageTitle: 'systemSetting.title',
            permissions: [CONFIG.permissions.systemSetting.R]
        },
        canActivate: [UserRouteAccessCrudService]
    },
    // {
    //     path: 'system-setting/edit',
    //     component: SystemSettingEditComponent,
    //     data: {
    //         authorities: ['ROLE_ADMIN'],
    //         pageTitle: 'systemSetting.title',
    //         permissions: [CONFIG.permissions.systemSetting.U]
    //     },
    //     canActivate: [UserRouteAccessCrudService],
    // }, 
    // {
    //     path: 'system-setting/edit/:tabId',
    //     component: SystemSettingEditComponent,
    //     data: {
    //         authorities: ['ROLE_ADMIN'],
    //         pageTitle: 'systemSetting.title',
    //         permissions: [CONFIG.permissions.systemSetting.U]
    //     },
    //     canActivate: [UserRouteAccessCrudService],
    // },
    // {
    //     path: 'invoice-adjustment/:id/edit/:typeId',
    //     component: SystemSettingEditComponent,
    //     data: {
    //         authorities: ['ROLE_ADMIN'],
    //         pageTitle: 'invoiceAdjustment.title',
    //         permissions: [CONFIG.permissions.substituteInvoice.U]
    //     },
    //     canActivate: [UserRouteAccessCrudService],
    // }
];
